module.exports = __webpack_public_path__ + "static/media/phone-solid.48c08549.svg";